import {
  LastMinutePackageSchema,
  PackageSchema,
} from '~entities/package/model/package.contracts';
import { Offering } from '../model/offering.types';
import { RoomSchema } from '~entities/room/model/room.contracts';
import {
  LastMinutePackage,
  Package,
} from '~entities/package/model/package.types';
import { Room } from '~entities/room/model/room.types';

// Type guards

/**
 * Type guard for determining if an offering is a last minute package.
 *
 * @param offering The offering to check.
 *
 * @returns A type predicate indicating if the offering is a last minute package.
 */
export const isLastMinutePackage = (
  offering?: Offering,
): offering is LastMinutePackage =>
  LastMinutePackageSchema.safeParse(offering).success;

/**
 * Type guard for determining if an offering is a package.
 *
 * @param offering The offering to check.
 *
 * @returns A type predicate indicating if the offering is a package.
 */
export const isPackage = (offering?: Offering): offering is Package =>
  PackageSchema.safeParse(offering).success;

/**
 * Type guard for determining if an offering is a room.
 *
 * @param offering The offering to check.
 *
 * @returns A type predicate indicating if the offering is a room.
 */
export const isRoom = (offering?: Offering): offering is Room =>
  RoomSchema.safeParse(offering).success;

/**
 * Determines the type of an offering.
 *
 * @param offering The offering to determine the type of.
 *
 * @returns The type of the offering, or undefined if the type cannot be determined.
 */
export const getOfferingType = (offering?: Offering) => {
  if (!offering) return;

  if (isRoom(offering)) return 'ROOM';
  if (isPackage(offering)) return 'PACKAGE';
  if (isLastMinutePackage(offering)) return 'LAST_MINUTE_PACKAGE';

  return;
};
